import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Jackpot",
  date: new Date(2024, 7, 18),
  img: "/img/church.jpeg",
  video: "/videos/church.mp4",
  tracks: [
    {
      title: "Hot Diggity",
      src: "/songs/2024-08-28/hot_diggity.mp3",
      duration: 1418.904,
    },
    {
      title: "Bagels & Cream Cheese",
      src: "/songs/2024-08-28/bagels_and_cream_cheese.mp3",
      duration: 334.008,
    },
    {
      title: "Back To School Special",
      src: "/songs/2024-08-28/bts_special.mp3",
      duration: 982.344,
    },
    {
      title: "Plum Butter",
      src: "/songs/2024-08-28/plum_butter.mp3",
      duration: 962.184,
    },
    {
      title: "Autumn Approaches",
      src: "/songs/2024-08-28/autumn_approaches.mp3",
      duration: 659.088,
    },
    {
      title: "House Money",
      src: "/songs/2024-08-28/house_money.mp3",
      duration: 804.264,
    },
    {
      title: "Can Til Ever",
      src: "/songs/2024-08-28/can_til_ever.mp3",
      duration: 609.264,
    },
    {
      title: "Jamapalooza",
      src: "/songs/2024-08-28/jamapalooza.mp3",
      duration: 1764.072,
    },
    {
      title: "M.I.L.E. (Making It Look Easy)",
      src: "/songs/2024-08-28/mile.mp3",
      duration: 1474.608,
    },
    {
      title: "Escalation",
      src: "/songs/2024-08-28/escalation.mp3",
      duration: 1364.88,
    },
    {
      title: "Level Headed",
      src: "/songs/2024-08-28/level_headed.mp3",
      duration: 1003.344,
    },
  ],
};
export default album;
